export default __webpack_public_path__ + "static/media/form-vector-3.376970dd.png";